import {useRef,useState,useEffect} from "react"
import { BarChart, Bar,LabelList, XAxis, YAxis,Label, ResponsiveContainer } from 'recharts';
import styled from "styled-components";

const Signature = styled.div`
  font-size: 15px;
`;

const RaceChart = ()=>{
    const ws = useRef(null);
    const [hashtags,setHashtags] = useState([{}]);
    
    useEffect(() => {
        ws.current = new WebSocket("wss://www.mydatalab.fr:443");
        ws.current.onopen = () => console.log("ws opened");
        ws.current.onclose = () => console.log("ws closed");

        ws.current.onmessage = e => {
            const message = JSON.parse(e.data);
            setHashtags(message)
        };
        return () => {
        }
    }, [])


    return(
        <>
        <h1>Hashtag top trends</h1>
        <ResponsiveContainer width="100%" height="80%">
        <BarChart  data={hashtags} layout="vertical" margin={{ top: 0, right: 50, bottom: 10, left: 200 }}>
            <XAxis  type="number" >
                <Label value="Number of tweets (Last 10 minutes)" offset={-10} position="insideBottom" />
            </XAxis>
            <YAxis type="category" dataKey="hashtag" />
            <Bar dataKey="hashtag_count" fill="#1DA1F2" isAnimationActive={true} >
                <LabelList dataKey="hashtag_count" position="right" />
            </Bar>
        </BarChart>
        </ResponsiveContainer>
        <Signature>
            <p>Coded with 🤙🏻 by Baptiste Monpezat</p>
        </Signature>
        </>
    )
    

}

export default RaceChart